export enum AllocationMethod {
    ExactMl = 'exact_ml',
    ExactAlgo = 'exact_algo'
}
